import type { Settings } from "../types";
import { apiClient } from "./apiClient";
export const settingsApi = { get: () => apiClient<Settings>("/settings") };

